import { SkucmmsList } from "./SkucmmsList";

export default {
  list: SkucmmsList,
  recordRepresentation: (record: any) => `${record?.id ?? ""}`,
};

